import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { TypeObjCPV } from '../models/TypeObjCPV';
import { Step4 } from '../../../../shared/models/component-messages/formfnsimplerectificatif/step4';
@Component({
  selector: 'app-type-objCPV',
  templateUrl: './type-objCPV.component.html'
})
export class TypeObjCPVComponent implements OnInit {

  @Input() uid = '';
  public current_uid = 'TypeObjCPV'
  @Input() parentForm: FormGroup;
  @Input() cpv: TypeObjCPV;
  @Input() disabled: boolean;

  public step4 = new Step4();

  constructor() { }

  public ngOnInit() {}

  getUid() {
    return this.uid + '_SepSep_' + this.current_uid;
  }

  getStepId() {
    return this.uid.substring(0, this.uid.indexOf("SepSep"));
  }

}

